import { Link } from 'react-router-dom';
import { FaUniversity, FaGraduationCap, FaMoneyBillAlt } from 'react-icons/fa';
import examsData from './examsData.json';
import './Exams.css';
import SEO from '../common/SEO';

const Exams = ({ limit = false }) => {
  const displayedExams = limit ? examsData?.exams.slice(0, 4) : examsData?.exams;
  // Generate SEO data based on whether it's a limited view or full view
  const generateSeoData = () => {
    if (limit) {
      return {
        title: "Top Competitive Exams - My Exam World",
        description: "Explore details of top competitive exams including syllabus, previous year cutoffs, eligibility criteria, application fees, exam patterns, and question papers.",
        keywords: "competitive exams, top exams, exam details, syllabus, cutoffs, eligibility, application fees, exam pattern, question papers",
        url: "/"
      };
    } else {
      // Extract exam titles for keywords (limited to first 10)
      const examTitles = examsData?.exams.slice(0, 10).map(exam => exam.title) || [];
      const examCategories = [...new Set(examsData?.exams.map(exam => exam.category))];

      return {
        title: "All Competitive Exams - Complete Details | My Exam World",
        description: `Comprehensive details for ${examsData?.exams.length} competitive exams including syllabus, previous year cutoffs, eligibility criteria, application fees, exam patterns, and question papers.`,
        keywords: `competitive exams, all exams, exam details, syllabus, cutoffs, eligibility, application fees, ${examTitles.join(', ')}, ${examCategories.join(', ')}`,
        url: "/exams-details"
      };
    }
  };

  const seoData = generateSeoData();

  return (
    <div className="container mb-4">
      {/* SEO Component */}
      {!limit &&
        <SEO
          title={seoData.title}
          description={seoData.description}
          keywords={seoData.keywords}
          url={seoData.url}
          schema={{
            "@context": "https://schema.org",
            "@type": "ItemList",
            "name": "Competitive Exams Catalog",
            "numberOfItems": examsData?.exams.length || 0,
            "itemListElement": examsData?.exams.map((exam, index) => ({
              "@type": "ListItem",
              "position": index + 1,
              "name": exam.title,
              "url": `https://www.myexamworld.com/exams-details/${exam.slug}`
            })) || []
          }}
        />
      }
      <div className="exams-compact-header">
        <h2>Competitive Exams Details</h2>
        <p>Find all exam details like <strong>syllabus</strong>, <strong>previous year cutoffs</strong>, <strong>eligibility</strong>, <strong>application fees</strong>, <strong>exam pattern</strong>, and <strong>question papers</strong>.</p>
      </div>
      <div className="exams-compact-grid">
        {displayedExams.map((exam) => (
          <div key={exam.id} className="exam-compact-card">
            <div className="exam-compact-card-header">
              <div className="exam-compact-title-section">
                <h3 className="exam-compact-title">{exam.title}</h3>
                <span className="exam-compact-category">{exam.category}</span>
              </div>
              <div className="exam-compact-conducting-body">
                <FaUniversity className="exam-compact-icon" />
                <span>{exam.conductingBody}</span>
              </div>
            </div>

            <div className="exam-compact-card-body">
              <div className="exam-compact-details">
                <div className="exam-compact-detail-item">
                  <FaGraduationCap className="exam-compact-icon" />
                  <span className="exam-compact-detail-label">Eligibility:</span>
                  <span className="exam-compact-detail-value">{exam.eligibilityCriteria.education}</span>
                </div>
                <div className="exam-compact-detail-item">
                  <FaMoneyBillAlt className="exam-compact-icon" />
                  <span className="exam-compact-detail-label">Fees:</span>
                  <span className="exam-compact-detail-value">Gen: {exam.applicationfees?.general}</span>
                </div>
              </div>
            </div>

            <div className="exam-compact-card-footer">
              <Link to={`/exams-details/${exam.slug}`} className="exam-compact-link-btn">
                View Details
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                  <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708l2.147-2.146H4.5A.5.5 0 0 1 4 8z" />
                </svg>
              </Link>
            </div>
          </div>
        ))}
      </div>
      {limit && (
        <div className="view-all" style={{ marginTop: '2rem' }}>
          <Link to="/exams-details" className="btn-dark">View All Exams →</Link>
        </div>
      )}
    </div>
  );
};

export default Exams;